// extracted by css-extract-rspack-plugin
export default {"panel":"CommitGroup-module__panel__b_sg9Ag"};